<template>
    <div>
        <v-dialog v-model="dialogDoublon.model" width="500">
            <v-card>
                <v-card-title>{{ $storeUm6p.Label.Informations }}</v-card-title>
                <v-card-text>
                    <p>{{ dialogDoublon.texte }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogDoublon.model = false">
                        {{ $storeUm6p.Label.Fermer }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <small>Merci de saisir tous les frères et sœurs vivants et nés après {{ formatDate(MinDateNaissance) }}.</small>
        <v-layout row wrap xs12>
            <!-- debut dialog -->
            <v-dialog v-model="dialog" max-width="50%">
                <template v-slot:activator="{ on }">
                    <v-layout class="btn-dialog" align-start justify-end>
                        <v-btn
                        v-show="!$storeCommun.ReadOnly" 
                        dark 
                        v-on="on"
                        color="secondary">
                            {{$storeUm6p.Label.Ajouter}}
                        </v-btn>
                    </v-layout>
                </template>
                <v-form
                ref="form"
                v-model="valid">
                    <v-card>
                        <v-toolbar color="secondary" dark>
                            <v-toolbar-title>{{$storeUm6p.Label.Ajouter}}</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-row>
                                    <v-col col="6">
                                        <v-text-field 
                                        id="txt_nom"
                                        v-model="editedItem.Nom"
                                        :rules="$storeReglesBourse.obligatoire"
                                        :label="$storeUm6p.Label.Fratrie.Nom"
                                        class="asterisk"/>
                                    </v-col>
                                    <v-col col="6">
                                        <v-text-field 
                                        v-model="editedItem.Prenom"
                                        :rules="$storeReglesBourse.obligatoire"
                                        :label="$storeUm6p.Label.Fratrie.Prenom"
                                        class="asterisk"/>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col col="6">
                                        <v-menu 
                                            v-model="menu.dateNaissance"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto">
                                            <template #activator="{ on, attrs }">
                                                <v-text-field 
                                                    clearable
                                                    v-model="DateNaissanceFormated"
                                                    :label="$storeUm6p.Label.Fratrie.DateNaissance"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click:clear="editedItem.DateNaissance = null"
                                                    :rules="$storeReglesBourse.obligatoire" 
                                                    class="asterisk"/>
                                            </template>
                                            <v-date-picker v-model="editedItem.DateNaissance"
                                            :min="MinDateNaissance"
                                            :max="MaxDateNaissance"
                                            :rules="$storeReglesBourse.obligatoire"
                                            @input="menu.dateNaissance = false" />
                                        </v-menu>
                                    </v-col>
                                    <v-col col="6">
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col col="6">
                                        <v-autocomplete
                                        :label="$storeUm6p.Label.Fratrie.SituationHandicap"
                                        v-model="editedItem.SituationHandicap"
                                        :item-text="$storeCommun.ItemLang"
                                        item-value="id"
                                        :items="$storeCatalogue.OuiNon"
                                        clearable
                                        class="asterisk"
                                        :rules="$storeReglesBourse.obligatoire"
                                        @change="SituationHandicapChange(editedItem)"/>
                                    </v-col>
                                    <v-col col="6">
                                        <v-autocomplete
                                        v-show="editedItem.SituationHandicap == $storeCatalogue.DataId.Oui"
                                        :label="$storeUm6p.Label.Fratrie.TypeHandicap"
                                        v-model="editedItem.NatureHandicap"
                                        :item-text="$storeCommun.ItemLang"
                                        item-value="id"
                                        :items="$storeCatalogue.NatureHandicap"
                                        :rules="editedItem.SituationHandicap == $storeCatalogue.DataId.Oui 
                                        ? $storeReglesBourse.obligatoire : []"
                                        clearable
                                        class="asterisk"
                                        multiple/>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col col="6">
                                        <v-text-field
                                        :label="$storeUm6p.Label.Fratrie.NomPere"
                                        v-model="editedItem.NomPrenomPere"
                                        class="asterisk"
                                        :rules="$storeReglesBourse.obligatoire"/>
                                    </v-col>
                                    <v-col col="6">
                                        <v-text-field
                                        :label="$storeUm6p.Label.Fratrie.NomMere"
                                        v-model="editedItem.NomPrenomMere"
                                        class="asterisk"
                                        :rules="$storeReglesBourse.obligatoire"/>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small dark color="secondary" @click="close">{{$storeUm6p.Label.Annuler}}</v-btn>
                            <v-btn small dark color="secondary" @click="save" >{{$storeUm6p.Label.Valider}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <!-- fin dialog -->
        </v-layout>
        <!-- Début Liste langues -->
        <v-data-table 
        :headers="$storeUm6p.Label.Fratrie.HeadersTab" 
        :items="$storeCommun.ListeFratrie" 
        class="elevation-1" 
        disable-pagination 
        hide-default-footer>
            <template v-slot:item={item}>
                <tr v-if="!item.Supprimer">
                    <th class="text-xs-left">{{ item.Nom }}</th>
                    <th class="text-xs-left">{{ item.Prenom }}</th>
                    <th class="text-xs-left">{{ formatDate(item.DateNaissance) }}</th>
                    <th class="text-xs-left">{{ $storeCatalogue.AffichageCatalogue($storeCatalogue.OuiNon, item.SituationHandicap, $storeCommun.ItemLang) }}</th>
                    <th class="text-xs-left">{{ item.SituationHandicap == $storeCatalogue.DataId.Oui ? $storeCatalogue.AffichageCatalogueMultiple($storeCatalogue.NatureHandicap, item.NatureHandicap, $storeCommun.ItemLang) : "" }}</th>
                    <th>
                        <v-icon small class="mr-2" @click="editItem(item)" v-show="!$storeCommun.ReadOnly">{{ icons.mdiPencil }}</v-icon>
                        <v-icon small @click="deleteItem(item)" v-show="!$storeCommun.ReadOnly">{{ icons.mdiDelete }}</v-icon>
                    </th>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>
<script>
import moment from 'moment';
import {
    mdiPencil,
    mdiDelete,
} from '@mdi/js'
    export default {
        components: {},
        data() {
            return {
                // menu date 
                menu:{
                    dateNaissance:false,
                },
                // Icon importés depuis mdi/js pour les icones d'édition/suppression
                icons: {
                    mdiPencil,
                    mdiDelete,
                },
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCatalogue: this.$storeCatalogue,
                $storeDemandeBourse: this.$storeDemandeBourse,
                $storeCommun : this.$storeCommun,
                // dialog pour ouvrir/fermer la popup
                dialog: false, 
                
                // Dialog pour afficher un message de doublon
                dialogDoublon: {
                    model: false,
                    texte: "",
                },

                // Validation du formulaire
                valid : false, 

                // nom des colonnes
                headers: [
                    { text: 'Nom', value: 'nom' },
                    { text: 'Prenom', value: 'prenom' },
                    { text: 'Date de naissance', value: 'datenaissance' },
                    { text: 'En situation de handicap', value: 'situationhandicap' },
                    { text: 'Type de handicap', value: 'naturehandicap' },
                    { text: '', value: 'actions', sortable: false }
                ],

                // index de l'objet édité.
                editedIndex: -1,

                // Item local
                editedItem: {
                    Index:null,
                    IdCrypte:null,
                    Supprimer:false,
                    Nom:null, 
                    Prenom:null,
                    DateNaissance:null,
                    SituationHandicap:null,
                    NatureHandicap:null,
                    NomPrenomMere:null,
                    NomPrenomPere:null,
                    ListeAnnexesFirsi:[],
                },
            }
        },
        computed:{
            annee() {
                return moment(String(new Date())).subtract(20, 'year').format('YYYY');
            },
            DateNaissanceFormated() {
                return this.formatDate(this.editedItem.DateNaissance);
            },
            MinDateNaissance() {
                if(this.$storeCommun.DateAgeFratrie){
                    return moment(this.$storeCommun.DateAgeFratrie).format('YYYY-MM-DD');
                }

                return "1900-01-01";
            },
            MaxDateNaissance() {
                return moment(String(new Date())).format('YYYY-MM-DD');
            },
            DateAgeFratrieFormated(){
                if(this.$storeCommun.DateAgeFratrie){
                    return moment(this.$storeCommun.DateAgeFratrie, "YYYY-MM-DD").format('DD/MM/YYYY');
                }

                return "01/01/1900"
            }
        },
        methods: {
            SituationHandicapChange(item){
                if(item.SituationHandicap === this.$storeCatalogue.DataId.Non){
                    item.NatureHandicap = [];
                }
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            editItem(item) {
                // Récupère l'item à éditer et l'affecte à editItem local pour remplir les rubriques du formulaire popup.
                this.editedIndex = this.$storeCommun.ListeFratrie.indexOf(item)
                this.editedItem = Object.assign({}, item)

                // ouvre le popup
                this.dialog = true
            },
            deleteItem(item) {
                if (confirm("Etes-vous sûr de vouloir supprimer cette ligne?")) {
                    // on récupère l'item depuis le store
                    this.editedIndex = this.$storeCommun.ListeFratrie.indexOf(item)
                    // on affecte l'item local pour récupèrer les valeurs
                    this.editedItem = Object.assign({}, item)

                    // on affecte la valeur supprimer à true
                    this.editedItem.Supprimer = true;

                    // on modifie l'item dans le store
                    Object.assign(this.$storeCommun.ListeFratrie[this.editedIndex], this.editedItem)
                    // appel le close pour désaffecter l'item local
                    this.close();
                }
            },
            close() {
                // RAZ des champs du formulaire
                this.$refs.form.resetValidation();

                // ferme le popup
                this.dialog = false;
                // on remet à zéro le editedItem local
                this.editedItem = Object.assign({}, {
                    Index:null,
                    IdCrypte:null,
                    Supprimer:false,
                    Nom:null, 
                    Prenom:null,
                    DateNaissance:null,
                    SituationHandicap:null,
                    NatureHandicap:null,
                    NomPrenomMere:null,
                    NomPrenomPere:null,
                    ListeAnnexesFirsi:[],
                });

                this.editedIndex = -1;
            },
            save() {
                // validation du formulaire
                this.$refs.form.validate();
                if(!this.valid){
                    return;
                }

                // Vérification des doublons (nom, prénom, date de naissance)
                const doublon = this.$storeCommun.ListeFratrie.some((item, index) => {
                    return index !== this.editedIndex && 
                           !item.Supprimer &&
                           item.Nom?.toLowerCase() === this.editedItem.Nom?.toLowerCase() &&
                           item.Prenom?.toLowerCase() === this.editedItem.Prenom?.toLowerCase() &&
                           item.DateNaissance === this.editedItem.DateNaissance;
                });

                if (doublon) {
                    this.dialogDoublon.texte = "Une personne avec le même nom, prénom et date de naissance existe déjà dans la liste.";
                    this.dialogDoublon.model = true;
                    return;
                }

                // on passe le item local à false.
                this.editedItem.Supprimer = false;
                // on modifie l'item dans le store si l'editedIndex est renseigné.
                if (this.editedIndex > -1) {
                    Object.assign(this.$storeCommun.ListeFratrie[this.editedIndex], this.editedItem)
                }
                // sinon, on ajoute l'item local au store.
                else {
                    this.editedItem.Index = this.$storeCommun.ListeFratrie.length+1;
                    this.$storeCommun.ListeFratrie.push(this.editedItem)
                }

                // on appelle close pour raz l'item local + fermer le popup
                this.close();
            },
        },
    }
</script>
<style scoped src="@/assets/css/DemandeBourse.css">
</style>